import React, {useState, useEffect} from 'react';
import {Button, Select, MenuItem, Dialog, DialogTitle, DialogContent, TextField, DialogActions} from "@mui/material";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import './FAQManager.css';
import axios from "axios";
import JoditEditor from "jodit-react";

function FAQManager({updateKey}) {
    const [faqs, setFaqs] = useState([]);
    const [selectedFaqId, setSelectedFaqId] = useState('');
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
    const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
    const [editFaq, setEditFaq] = useState({id: '', title: '', description: '', titleEng: '', descriptionEng: ''});
    const [alertInfo, setAlertInfo] = useState({open: false, message: '', type: ''});
    const georgianTranslations = {
        "Type something": " ",
        "Bold": "ტექსტის გამუქება",
        "Italic": "დახრილი ტექსტის შექმნა",
        "Underline": "ტექსტის ხაზგასმა",
        "Insert Image": "სურათის ჩასმა",
        "Clear Formatting": "ფორმატირების წაშლა",
        "Insert Format Block": "ფორმატირების ბლოკის ჩასმა",
        "Strike through": "გადახაზული",
        "Insert Unordered List": "ბურთულებიანი სიის შექმნა",
        "Insert Ordered List": "დანომრილი სიის შექმნა",
        "Font family": "შრიფტის არჩევა",
        "Font size": "შრიფტის ზომა",
        "Line height": "ხაზის დაშორება",
        "Insert Horizontal Line": "ხაზის დაშორება",
        "Increase Indent": "დაშორების გაზრდა",
        "Decrease Indent": "დაშორების შემცირება",
        "Undo": "უკუსვლა",
        "Redo": "საწყისი",
        "Align": "სწორება",
        "Insert Special Character": "სპეც. სიმბოლო",
        "Fill color or set the text color": "ფერის შეცვლა",
        "Background": "ფონი",
        "Text": "ტექსტი",
        "Insert format block": "ფორმატირება",
        "Print": "დაბეჭვდა",
        "Show all": "მეტის ნახვა",
        "Insert link": "ბმლის ჩასმა",
        "URL": "ბმული",
        "Open in new tab": "ახალ გვერდზე გახსნა",
        "Insert": "ჩასმა"
    };

    const configGeo = {
        placeholder: "ტექსტი ქართულად...",
        readonly: false,
        toolbarButtonSize: "middle",
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        language: 'ka',
        i18n: {
            ka: georgianTranslations,
        },
        height: 400,
        width: 1100,
        disablePlugins: [
            'table',
            'spellcheck',
            'speech-recognize',
            'open-in-fullsize',
            'add-new-line',
            'Insert-file',
            'link',
            'ai-assistant',
            'file',
            'image',
            'video',
            'fullsize',
            'about',
            'preview',
            'symbols',
        ],
        controls: {
            font: {
                list: {
                    'Arial': 'Arial',
                    'Sylfaen': 'Sylfaen'
                }
            }
        },
        buttons: [
            'bold', 'italic', 'underline', 'strikethrough', '|',
            'ul', 'ol', '|',
            'outdent', 'indent', '|',
            'font', 'fontsize', 'brush', 'paragraph', '|',
            'image', 'table', 'link', '|',
            'align', 'undo', 'redo', '|',
            'hr', 'eraser', 'copyformat', '|',
            'symbol', 'fullsize', 'print', 'about'
        ],
    };

    const configEng = {
        placeholder: "ტექსტი ინგლისურად...",
        readonly: false,
        toolbarButtonSize: "middle",
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        language: 'ka',
        i18n: {
            ka: georgianTranslations,
        },
        height: 400,
        width: 1100,
        disablePlugins: [
            'table',
            'spellcheck',
            'speech-recognize',
            'open-in-fullsize',
            'add-new-line',
            'Insert-file',
            'link',
            'ai-assistant',
            'file',
            'image',
            'video',
            'fullsize',
            'about',
            'preview',
            'symbols',
        ],
        controls: {
            font: {
                list: {
                    'Arial': 'Arial',
                    'Sylfaen': 'Sylfaen'
                }
            }
        },
        buttons: [
            'bold', 'italic', 'underline', 'strikethrough', '|',
            'ul', 'ol', '|',
            'outdent', 'indent', '|',
            'font', 'fontsize', 'brush', 'paragraph', '|',
            'image', 'table', 'link', '|',
            'align', 'undo', 'redo', '|',
            'hr', 'eraser', 'copyformat', '|',
            'symbol', 'fullsize', 'print', 'about'
        ],
    };


    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/GetAllFAQ`)
            .then(response => response.json())
            .then(data => {
                if (data.success && data.data) {
                    setFaqs(data.data);
                }
            })
            .catch(console.error);
    }, [updateKey]);

    const handleDropdownChange = (event) => {
        setSelectedFaqId(event.target.value);
    };

    const handleDeleteFaq = async () => {
        setIsConfirmationModalOpen(false);
        try {
            const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/DeleteFAQ`, { id: selectedFaqId });
            if (response.status === 200) {
                setFaqs(faqs.filter(faq => faq.id !== selectedFaqId));
                setAlertInfo({open: true, message: 'ოპერაცია წარმატებით დასრულდა', type: 'success'});
            } else {
                setAlertInfo({open: true, message: 'დაფიქსირდა შეცდომა, ცადეთ მოგვიანებით!', type: 'error'});
            }
        } catch {
            setAlertInfo({open: true, message: 'დაფიქსირდა შეცდომა, ცადეთ მოგვიანებით!', type: 'error'});
        }
    };

    const handleEditClick = () => {
        if (!selectedFaqId) return;
        const selectedFaq = faqs.find(faq => faq.id === selectedFaqId);
        if (selectedFaq) {
            setEditFaq({...selectedFaq});
            setIsEditDialogOpen(true);
        }
    };

    const handleEditChange = (e) => {
        setEditFaq({...editFaq, [e.target.name]: e.target.value});
    };

    const handleEditorChange = (field, value) => {
        setEditFaq({...editFaq, [field]: value});
    };

    const handleEditSubmit = async () => {
        try {
            const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditFAQ`, editFaq);
            if (response.status === 200) {
                setFaqs(faqs.map(faq => faq.id === editFaq.id ? editFaq : faq));
                setAlertInfo({open: true, message: 'ცვლილება შენახულია წარმატებით', type: 'success'});
                setIsEditDialogOpen(false);
            } else {
                setAlertInfo({open: true, message: 'შეცდომა ცვლილების შენახვისას', type: 'error'});
            }
        } catch {
            setAlertInfo({open: true, message: 'შეცდომა ცვლილების შენახვისას', type: 'error'});
        }
    };

    const handleDeleteClick = () => {
        if (selectedFaqId) {
            setIsConfirmationModalOpen(true);
        }
    };

    return (
        <div className="faq-manager-container">
            <h1 className="employee-form-title">კითხვის წაშლა/რედაქტირება</h1>

            <Select
                className="faq-select"
                value={selectedFaqId}
                onChange={handleDropdownChange}
                displayEmpty
            >
                <MenuItem value="">აირჩიეთ კითხვა</MenuItem>
                {faqs.map(faq => (
                    <MenuItem key={faq.id} value={faq.id}>
                        {faq.title || faq.titleEng}
                    </MenuItem>
                ))}
            </Select>

            <div style={{marginTop: 16}}>
                <Button onClick={handleDeleteClick} color="primary" variant="contained" disabled={!selectedFaqId}>
                    წაშლა
                </Button>
                <Button onClick={handleEditClick} color="secondary" variant="contained" style={{marginLeft: 12}} disabled={!selectedFaqId}>
                    რედაქტირება
                </Button>
            </div>

            <ConfirmationModal
                isOpen={isConfirmationModalOpen}
                onRequestClose={() => setIsConfirmationModalOpen(false)}
                onConfirm={handleDeleteFaq}
            />

            <Dialog open={isEditDialogOpen} onClose={() => setIsEditDialogOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>კითხვის რედაქტირება</DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        name="title"
                        label="კითხვა"
                        value={editFaq.title}
                        onChange={handleEditChange}
                        margin="dense"
                    />
                    <div style={{marginTop: 10}}>
                        <JoditEditor
                            value={editFaq.description}
                            config={configGeo}
                            onBlur={(value) => handleEditorChange("description", value)}
                        />
                    </div>
                    <TextField
                        fullWidth
                        name="titleEng"
                        label="კითხვა (ინგლისურად)"
                        value={editFaq.titleEng}
                        onChange={handleEditChange}
                        margin="dense"
                        style={{marginTop: 20}}
                    />
                    <div style={{marginTop: 10}}>
                        <JoditEditor
                            value={editFaq.descriptionEng}
                            config={configEng}
                            onBlur={(value) => handleEditorChange("descriptionEng", value)}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsEditDialogOpen(false)}>დახურვა</Button>
                    <Button onClick={handleEditSubmit} variant="contained" color="primary">შენახვა</Button>
                </DialogActions>
            </Dialog>

            {alertInfo.open && (
                <CustomAlert
                    message={alertInfo.message}
                    type={alertInfo.type}
                    onClose={() => setAlertInfo({open: false, message: '', type: ''})}
                />
            )}
        </div>
    );
}

export default FAQManager;
